<template>
  <div id="evpAddOns">
    <div class="report-loader text-center" v-if="loading">
      <img src="/images/loading.gif" />
    </div>
    <div v-else>
      <div
        v-for="(indicator, i) in indicators"
        v-bind:key="'indicator' + i"
        :id="'indicator' + i"
        :style="
          slug === 'indicator' + i || preview === true ? '' : 'display:none;'
        "
      >
        <IndicatorCompareComponent
          ref="indicator"
          :indicatorData="indicator"
          :rowNumber="i"
          :preview="preview"
          :reportAddOns="'1'"
          :isDivision="false"
          :isMarketIncluded="false"
          :chartID="indicatorChart + i"
          :tableID="'indicatorDataTable' + i"
          :reportTypeId="reportTypeId"
        />
      </div>

      <div
        v-for="(division, i) in divisions"
        v-bind:key="'division' + i"
        :id="'division' + i"
        :style="
          slug === 'division' + i || preview === true ? '' : 'display:none;'
        "
      >
        <IndicatorCompareComponent
          ref="division"
          :indicatorData="division"
          :rowNumber="i"
          :preview="preview"
          :reportAddOns="'1'"
          :isDivision="true"
          :isMarketIncluded="false"
          :chartID="divisionChart + i"
          :tableID="'divisionTable' + i"
          :reportTypeId="reportTypeId"
        />
      </div>

      <div
        v-for="(division, i) in companyToDivision"
        v-bind:key="'companyToDivision' + i"
        :id="'companyToDivision' + i"
        :style="
          slug === 'companyToDivision' + i || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <DivisionComparisonComponent
          ref="companyToDivision"
          :divisionData="division"
          :companyName="companyName"
          :rowNumber="i"
          :chartID="'companyToDivisionChart' + i"
          :reportTypeId="reportTypeId"
        />
      </div>

      <div
        v-for="(dataMarketIndicator, i) in dataMarketIndicator"
        v-bind:key="'dataMarketIndicator' + i"
        :id="'dataMarketIndicator' + i"
        :style="
          slug === 'dataMarketIndicator' + i || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <IndicatorCompareComponent
          ref="dataMarketIndicator"
          :indicatorData="dataMarketIndicator"
          :rowNumber="i"
          :preview="preview"
          :reportAddOns="'1'"
          :isDivision="false"
          :isMarketIncluded="true"
          :chartID="marketIndicator + i"
          :reportTypeId="reportTypeId"
        />
      </div>

      <div
        v-for="(multiDT, i) in multiDT"
        v-bind:key="'multi-data' + i"
        :id="'multi-data' + i"
        :style="
          slug === 'multi-data' + i || preview === true ? '' : 'display:none;'
        "
      >
        <multi-data-component
          ref="multiData"
          :companyName="companyName"
          :consulting_slug="consulting_slug"
          :multiDT="multiDT"
          :rowNumber="i"
          :preview="preview"
          :chartID="'multiDataChart' + i"
          :reportTypeId="reportTypeId"
        />
      </div>

      <template v-if="forecastData">
        <div
          :style="
            slug === 'forecast' || preview === true ? '' : 'display:none;'
          "
        >
          <ForecastComponent
            :companyName="companyName"
            :consulting_slug="consulting_slug"
            :forecastData="forecastData"
            :monthEnd="monthEnd"
            :tableID="'forecastTable'"
            :addon="true"
            :reportTypeId="reportTypeId"
          />
        </div>
      </template>

      <template v-if="fcHistoryPage">
        <div
          :style="
            slug === 'forecast-history' || preview === true
              ? ''
              : 'display:none;'
          "
        >
          <ForecastHistoryComponent
            :companyName="companyName"
            :consulting_slug="consulting_slug"
            :fcHistoryPage="fcHistoryPage"
            :tableID="'forecastHistoryTable'"
            :reportTypeId="reportTypeId"
          />
        </div>
      </template>

      <template v-if="indicatorDefinitions">
        <div
          :style="
            slug === 'indicator-definitions' || preview === true
              ? ''
              : 'display:none;'
          "
        >
          <DefinitionOfIndicatorsComponent
            :indicatorDefinitions="indicatorDefinitions"
            :reportTypeId="reportTypeId"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import IndicatorCompareComponent from '~/components/report/modules/live-report/shared/IndicatorCompareComponent.vue';
  import MultiDataComponent from '~/components/report/modules/live-report/shared/MultiDataComponent.vue';
  import ForecastComponent from '~/components/report/modules/live-report/shared/ForecastComponent.vue';
  import ForecastHistoryComponent from '~/components/report/modules/live-report/shared/ForecastHistoryComponent.vue';
  import DivisionComparisonComponent from '~/components/report/modules/live-report/shared/DivisionComparisonComponent.vue';
  import DefinitionOfIndicatorsComponent from '~/components/report/modules/live-report/shared/DefinitionOfIndicatorsComponent.vue';
  import pptxgen from 'pptxgenjs';
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';

  export default {
    name: 'EVPFlexAddOnComponent',
    props: {
      slug: {
        type: String,
        default: '',
      },
      index: {
        type: [Number, String],
        default: '',
      },
      preview: {
        type: Boolean,
        default: false,
      },
      consulting_slug: {
        type: String,
        default: '',
      },
      apiResponse: {
        type: Object,
        default: () => ({}),
      },
      reportID: {
        type: [Number, String],
        default: '',
      },
      reportTypeId: {
        type: [Number, String],
        default: '',
      },
    },
    components: {
      IndicatorCompareComponent,
      MultiDataComponent,
      ForecastComponent,
      ForecastHistoryComponent,
      DivisionComparisonComponent,
      DefinitionOfIndicatorsComponent,
    },
    data() {
      return {
        loading: true,
        companyName: '',
        productType: '',
        indicatorDefinitions: null,
        multiDT: [],
        divisions: [],
        indicators: [],
        companyToDivision: [],
        forecastData: null,
        fcHistoryPage: null,
        dataMarketIndicator: {},
        forecastBar: '',
        wasRevised: '',
        wasRevised1: '',
        wasRevised2: '',
        wasRevised3: '',
        monthEnd: [],
        currentYear: new Date().getFullYear(),
        indicatorChart: 'indicatorChart',
        divisionChart: 'divisionChart',
        marketIndicator: 'marketIndicator',
        indicatorSimpleChart: 'indicatorSimpleChart',
      };
    },
    mounted() {
      this.setData();
      var divW = jQuery('#evpAddOns').width();
      setInterval(function () {
        var w = jQuery('#evpAddOns').width();
        if (w != divW) {
          $('#forecastTable').DataTable().columns.adjust();
          divW = w;
        }
      }, 100);
    },
    updated() {
      if (!this.preview) {
        if (this.slug === 'indicator' + this.index) {
          Plotly.Plots.resize('indicatorChart' + this.index);
        } else if (this.slug === 'multi-data' + this.index) {
          Plotly.Plots.resize('multiDataChart' + this.index);
        } else if (this.slug === 'forecast') {
          $('#forecastTable').DataTable().columns.adjust();
        } else if (this.slug === 'division' + this.index) {
          Plotly.Plots.resize('divisionChart' + this.index);
        } else if (this.slug === 'dataMarketIndicator' + this.index) {
          Plotly.Plots.resize('marketIndicator' + this.index);
        } else if (this.slug === 'indicatorSimple' + this.index) {
          Plotly.Plots.resize('indicatorSimpleChart' + this.index);
        } else if (this.slug === 'companyToDivision' + this.index) {
          Plotly.Plots.resize('companyToDivisionChart' + this.index);
        }
      }
    },
    methods: {
      async getReportLogo() {
        let companyLogoImage = await this.getOnlyCompanyLogo();
        if (!companyLogoImage) {
          companyLogoImage = this.getBase64Image(
            document.getElementById('itrLogo')
          );
        }

        return companyLogoImage;
      },
      async getOnlyCompanyLogo() {
        let companyLogoImage = null;

        try {
          const { data } = await axios.get(
            `/company-logo/report/${this.reportID}/image-data-url`
          );
          companyLogoImage = data;
        } catch (error) {
          //
        }

        return companyLogoImage;
      },
      setData() {
        this.companyName = this.apiResponse.CompanyName ?? '';
        this.productType = this.apiResponse.CoverPage.ProductType ?? '';

        //definition page
        if (
          this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
            .length > 0
        ) {
          this.indicatorDefinitions = {
            evenRows: [],
            oddRows: [],
            definitions:
              this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows,
          };

          for (
            let i = 0;
            i <
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
              .length;
            ++i
          ) {
            if (i % 2 === 0) {
              this.indicatorDefinitions.evenRows.push(
                this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[
                  i
                ]
              );
            } else {
              this.indicatorDefinitions.oddRows.push(
                this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[
                  i
                ]
              );
            }
          }
        }
        //indicators
        if (this.apiResponse.IndicatorDetailPages) {
          for (
            let index = 0;
            index < this.apiResponse.IndicatorDetailPages.length;
            index++
          ) {
            const element = this.apiResponse.IndicatorDetailPages[index];
            this.indicators.push(element);
          }
        }
        // this.indicators = this.apiResponse.IndicatorDetailPages ?? [];

        if (this.apiResponse.IndicatorSimplePages) {
          for (
            let index = 0;
            index < this.apiResponse.IndicatorSimplePages.length;
            index++
          ) {
            const element = this.apiResponse.IndicatorSimplePages[index];
            this.indicators.push(element);
          }
        }

        //map multi chart
        this.multiDT = this.apiResponse.MultidataComparisonPages ?? {};

        //division data passed to indicator page
        this.divisions = this.apiResponse.DivIndDetailPages ?? [];
        if (this.apiResponse.DivIndSimplePages) {
          for (
            let index = 0;
            index < this.apiResponse.DivIndSimplePages.length;
            index++
          ) {
            const element = this.apiResponse.DivIndSimplePages[index];
            this.divisions.push(element);
          }
        }

        //company to division
        this.companyToDivision = this.apiResponse.RoCDivPages ?? [];

        // Company Data & Custom Market Index to Indicator
        this.dataMarketIndicator = this.apiResponse.CoMIIndPages;

        this.fcHistoryPage = this.apiResponse.FCHistoryPage ?? null;

        //forecast history
        if (this.fcHistoryPage !== null) {
          this.wasRevised1
            ? this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1
            : '';
          this.wasRevised2
            ? this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2
            : '';
          this.wasRevised3
            ? this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3
            : '';
        }

        //forecast
        this.forecastData = this.apiResponse.ForecastTablePage ?? null;
        if (this.forecastData?.ForecastTable.Rows.length > 0) {
          this.forecastBar =
            this.apiResponse.ForecastTablePage.ForecastRevisedText;
          var monthArray = [];
          var monthArrayFinal = [];

          for (
            let i = 0;
            i < this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
            ++i
          ) {
            monthArray.push(
              this.apiResponse.ForecastTablePage.ForecastTable.Headers[
                i
              ].replace(/[0-9]/g, '')
            );
            monthArrayFinal.push(monthArray[i].replace(/-/g, ''));
          }

          this.monthEnd = monthArrayFinal;
        }

        this.buildPageDropDownMenu();
      },
      buildPageDropDownMenu() {
        var pages = document.getElementById('report-page');
        pages.innerHTML = '';

        for (var i = 0; i < this.apiResponse.PageOrder.length; i++) {
          var option = document.createElement('option');
          option.text = this.apiResponse.PageOrder[i].Text;
          option.value = this.apiResponse.PageOrder[i].Value;
          option.setAttribute('index', this.apiResponse.PageOrder[i].Attribute);
          option.selected = i === 0;
          pages.add(option);
        }

        if (!this.preview) {
          //handle paginations
          document.getElementById('paginationPagesLabel').innerHTML =
            pages.selectedIndex + 1 + '/' + pages.length;
        }

        this.loading = false;
      },
      async downloadPDF() {
        pdfMake.vfs = pdfFonts;

        let companyLogoImageDataUrl = await this.getOnlyCompanyLogo();
        if (!companyLogoImageDataUrl) {
          companyLogoImageDataUrl = 'itrLogo';
        }

        // this.apiResponse.IndicatorPages[i].ChartTitle
        for (let i = 0; i < this.indicators.length; ++i) {
          var chartTitleFontSize = 30;
          if (this.indicators[i].ChartTitle.length >= 70) {
            chartTitleFontSize = 10;
          } else if (this.indicators[i].ChartTitle.length >= 40) {
            chartTitleFontSize = 12;
          } else if (this.indicators[i].ChartTitle.length >= 20) {
            chartTitleFontSize = 18;
          } else if (this.indicators[i].ChartTitle.length >= 15) {
            chartTitleFontSize = 25;
          }
        }

        //create cover page chart
        await this.createCoverPageChart();

        //create cover page
        var coverPage = [
          {
            fit: [200, 200],
            alignment: 'center',
            image: 'itrLogo',
            margin: [0, 0, 0, 15],
          },
          {
            text: this.apiResponse.CoverPage.ProductType,
            fontSize: 62,
            alignment: 'center',
            bold: true,
            italics: true,
            style: 'darkBlue',
            margin: [0, 0, 0, 15],
          },
          {
            text: [
              '=====================================================     ',
              {
                text: this.apiResponse.CoverPage.ReportDate,
              },
              '     ==========',
            ],
            style: 'darkBlue',
            alignment: 'center',
            margin: [0, 0, 0, 15],
          },
          {
            text: this.apiResponse.CompanyName,
            style: 'darkBlue',
            bold: true,
            alignment: 'center',
            fontSize: 14,
          },
          {
            image: await Plotly.toImage('coverPageChart', {
              format: 'png',
              width: 800,
              height: 600,
            }),
            height: 150,
            width: 300,
            alignment: 'center',
          },
          {
            margin: [200, 20, 0, 15],
            alignment: 'center',
            columnGap: 5,
            columns: [
              {
                image: 'phaseAFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseBFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseCFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseDFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
            ],
          },
          {
            bold: true,
            style: 'darkBlue',
            text: '603.796.2500 | reports@itreconomics.com',
            alignment: 'center',
          },
          {
            bold: true,
            style: 'darkBlue',
            text: 'www.itrondemand.com',
            link: 'https://www.itrondemand.com',
            alignment: 'center',
          },
        ];

        {
          //forecast
          if (this.apiResponse.ForecastTablePage !== null) {
            var forecastPage = [
              {
                pageBreak: 'before',
                columnGap: 5,
                columns: [
                  {
                    fit: [95, 95],
                    image: this.getBase64Image(
                      document.getElementById('itrLogo')
                    ),
                  },
                  {
                    width: '65%',
                    alignment: 'center',
                    fontSize: 14,
                    bold: true,
                    text: this.apiResponse.ForecastTablePage.TableTitle,
                  },
                  {
                    fit: [95, 95],
                    alignment: 'right',
                    image: companyLogoImageDataUrl,
                  },
                ],
              },
            ];

            var forecastPageTable = {
              layout: 'lightHorizontalLines',
              margin: [0, 10, 0, 10],
              fontSize: 7,
              table: {
                headerRows: 1,
                widths: [],
                body: [],
              },
            };

            let longForecast = false;
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length >
                0 &&
              this.apiResponse.ForecastTablePage.ForecastTable.Rows[0]
                .ForecastColumns.length > 13
            ) {
              longForecast = true;
              forecastPageTable.fontSize = 6;
              forecastPageTable.margin = [-20, 10, -10, 10];
            }

            var fcTableHeaders = [];
            for (
              let i = 0;
              i <
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
              i++
            ) {
              const element =
                this.apiResponse.ForecastTablePage.ForecastTable.Headers[i];
              var headerIndex = i;
              var fiscalMonthEnd =
                this.apiResponse.ForecastTablePage.FiscalYearEndMonth;
              // if (i > 0 && this.apiResponse.ForecastTablePage.HideFirstColumn) {
              //     headerIndex = headerIndex - 1;
              // }
              var monthEnd = this.monthEnd[headerIndex];

              if (
                i === 1 &&
                this.apiResponse.ForecastTablePage.HideFirstColumn
              ) {
                if (
                  headerIndex === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  if (
                    monthEnd === fiscalMonthEnd &&
                    this.apiResponse.ForecastTablePage.ForecastTable.Headers
                      .length -
                      1 !==
                      headerIndex
                  ) {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push('');
                  } else {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push('');
                  }
                } else if (
                  monthEnd === fiscalMonthEnd &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    headerIndex
                ) {
                  forecastPageTable.table.widths.push('auto');
                  fcTableHeaders.push('');
                }
              } else {
                fcTableHeaders.push(element);

                if (
                  headerIndex === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  if (
                    monthEnd === fiscalMonthEnd &&
                    this.apiResponse.ForecastTablePage.ForecastTable.Headers
                      .length -
                      1 !==
                      headerIndex
                  ) {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push('');
                  } else {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push('');
                  }
                } else if (
                  monthEnd === fiscalMonthEnd &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    headerIndex
                ) {
                  forecastPageTable.table.widths.push('auto');
                  fcTableHeaders.push('');
                }

                if (i === 0)
                  if (longForecast) {
                    forecastPageTable.table.widths.push(60);
                  } else {
                    forecastPageTable.table.widths.push(150);
                  }
                else forecastPageTable.table.widths.push('auto');
              }
            }

            forecastPageTable.table.body.push(fcTableHeaders);

            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.ForecastTable.Rows.length;
              i++
            ) {
              const row =
                this.apiResponse.ForecastTablePage.ForecastTable.Rows[i];

              var index = i;
              var actuals = parseFloat(
                this.forecastData.ForecastTable.Rows[7].ForecastColumns[0]
              );
              var lowerRange = parseFloat(
                this.forecastData.ForecastTable.Rows[4].ForecastColumns[0]
              );
              var upperRange = parseFloat(
                this.forecastData.ForecastTable.Rows[6].ForecastColumns[0]
              );

              if (
                i > 0 &&
                this.apiResponse.ForecastTablePage.ForecastTable.Rows[i - 1]
                  .RowTitle === 'Actual'
              ) {
                var tempRows = this.buildEmptyForecastRow();
                forecastPageTable.table.body.push(tempRows);
              }

              var fcRow = [
                {
                  text: row.RowTitle,
                  alignment: 'center',
                  bold:
                    row.RowTitle === 'Actual' ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly')
                      ? true
                      : false,
                },
              ];

              for (let x = 0; x < row.ForecastColumns.length; x++) {
                const element = row.ForecastColumns[x];

                if (
                  x === 0 &&
                  this.apiResponse.ForecastTablePage.HideFirstColumn
                )
                  continue;

                if (
                  x === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  if (this.forecastBar === 'Forecast Revised') {
                    fcRow.push({
                      fit: [100, 220],
                      image: this.getBase64Image(
                        document.getElementById('forecastRevisedBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  } else if (this.forecastBar === 'Data Trends Adjusted') {
                    fcRow.push({
                      fit: [100, 220],
                      image: this.getBase64Image(
                        document.getElementById('dataTrendsBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  } else if (this.forecastBar === 'Rates-of-Change Adjusted') {
                    fcRow.push({
                      fit: [100, 220],
                      image: this.getBase64Image(
                        document.getElementById('ratesOfChangeBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  }
                } else if (
                  this.monthEnd[x] ===
                    this.apiResponse.ForecastTablePage.FiscalYearEndMonth &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    x
                ) {
                  fcRow.push({
                    text: '',
                    alignment: 'center',
                  });
                }

                if (row.RowTitle === 'Actual') {
                  fcRow.push({
                    text: element,
                    alignment: 'center',
                    bold: true,
                    color:
                      actuals >= lowerRange && actuals <= upperRange
                        ? '#09A684'
                        : '#D2232A',
                  });
                } else {
                  fcRow.push({
                    text: element,
                    alignment: 'center',
                    bold:
                      row.RowTitle.includes('Annual') ||
                      row.RowTitle.includes('Quarterly')
                        ? true
                        : false,
                  });
                }
              }

              forecastPageTable.table.body.push(fcRow);
            }

            forecastPage.push(forecastPageTable);

            var outlookText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Outlook',
                      fillColor: '#65A9D2',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                  // [{
                  //     ul: [
                  //         this.apiResponse.ForecastTablePage.Outlook
                  //     ]
                  // }]
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#65A9D2';
                },
                vLineColor: function () {
                  return '#65A9D2';
                },
              },
            };

            var outlookUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Outlook.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Outlook[i];
              outlookUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              outlookText.table.body.push([
                {
                  ul: outlookUL,
                },
              ]);
            }

            // forecastPage.push(outlookText);

            var resultsText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Results',
                      fillColor: '#5AB5A2',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                  // [{
                  //     ul: [
                  //         this.apiResponse.ForecastTablePage.Outlook
                  //     ]
                  // }]
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#5AB5A2';
                },
                vLineColor: function () {
                  return '#5AB5A2';
                },
              },
            };

            var resultsUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Results.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Results[i];
              resultsUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              resultsText.table.body.push([
                {
                  ul: resultsUL,
                },
              ]);
            }

            // forecastPage.push(resultsText);

            var evidence = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Supporting Evidence',
                      fillColor: '#183961',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#183961';
                },
                vLineColor: function () {
                  return '#183961';
                },
              },
            };

            var evidenceUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Evidence.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Evidence[i];
              evidenceUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              evidence.table.body.push([
                {
                  ul: evidenceUL,
                },
              ]);
            }

            // forecastPage.push(evidence);

            var risks = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Risks',
                      fillColor: '#006742',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#006742';
                },
                vLineColor: function () {
                  return '#006742';
                },
              },
            };

            var risksUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Risks.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Risks[i];
              risksUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              risks.table.body.push([
                {
                  ul: risksUL,
                },
              ]);
            }
            // forecastPage.push(risks);

            var forecastTextColumns = [
              {
                columnGap: 5,
                columns: [outlookText, resultsText, evidence, risks],
              },
            ];

            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              forecastPage.push(forecastTextColumns);
            }
          }
        } //Forecast end

        {
          //divisions
          var divisions = [];
          for (let i = 0; i < this.divisions.length; ++i) {
            var indicator = [
              {
                pageBreak: 'before',
                text: '',
              },
            ];
            if (
              this.divisions[i].Headline !== null &&
              this.divisions[i].Headline !== ''
            ) {
              indicator.push({
                table: {
                  widths: ['*'],
                  header: 1,
                  alignment: 'center',
                  body: [
                    [
                      {
                        text: this.divisions[i].Headline,
                        fillColor:
                          this.preview && this.divisions[i].HeadlineIsProofed
                            ? 'yellow'
                            : '',
                        alignment: 'center',
                        fontSize: 12,
                        bold: true,
                      },
                    ],
                  ],
                },
                layout: {
                  hLineColor: function () {
                    return '#09A684';
                  },
                  vLineColor: function () {
                    return '#09A684';
                  },
                  paddingLeft: function () {
                    return 20;
                  },
                  paddingRight: function () {
                    return 20;
                  },
                  paddingTop: function () {
                    return 5;
                  },
                  paddingBottom: function () {
                    return 5;
                  },
                },
                margin: [0, -35, 0, 0],
              });
            }

            var divisionNotesTable = {
              table: {
                widths: ['*'],
                body: [],
              },
              layout: {
                hLineWidth: function (i, node) {
                  var notesLenght = node.table.body.length;
                  return i === notesLenght ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                paddingLeft: function (i, node) {
                  return 30;
                },
                paddingTop: function (i, node) {
                  return 0;
                },
                paddingBottom: function (i, node) {
                  return 1;
                },
              },
            };

            var divisionNotes = [];

            for (var x = 0; x < this.divisions[i].ExtraNotes.length; x++) {
              if (this.divisions[i].ExtraNotes[x].includes('<a href='))
                continue;

              divisionNotes.push([
                {
                  text: [
                    this.divisions[i].ExtraNotes.length > 0
                      ? { text: 'Note: ', bold: true }
                      : '',
                    this.divisions[i].ExtraNotes.length > 0
                      ? this.divisions[i].ExtraNotes[x]
                      : '',
                  ],
                  fontSize: 8,
                },
              ]);
            }

            divisionNotes.push([
              {
                text: [
                  this.divisions[i].OnDemandLink
                    ? 'Complete Indicator Analysis: '
                    : '',
                  {
                    text: this.divisions[i].OnDemandLink ? 'ITR onDemand' : '',
                    link: this.divisions[i].OnDemandLink,
                    bold: true,
                    decoration: 'underline',
                    color: '#0000ff',
                  },
                ],
                fontSize: 8,
              },
            ]);

            divisionNotesTable.table.body = divisionNotes;

            indicator.push(
              {
                text: this.divisions[i].ChartTitle,
                fontSize: chartTitleFontSize,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                // image: await this.$refs.division[i].pushToImage(800, 500),
                image: $('#divisionChart' + i + 'ChartImg').attr('src'),
                width: 600,
                height: 325,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              divisionNotesTable
            );

            // add chart image
            if (
              this.divisions[i].IndicatorRelevance &&
              this.divisions[i].IndicatorRelevance.length > 0
            ) {
              indicator.push({
                columns: [
                  [
                    {
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.divisions[i].IndicatorPhase === 'Phase A'
                          ? 'phaseAFrame'
                          : this.divisions[i].IndicatorPhase === 'Phase B'
                            ? 'phaseBFrame'
                            : this.divisions[i].IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.divisions[i].IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.divisions[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 80, 5],
                      width: 'auto',
                    },
                    {
                      text: this.divisions[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 80, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.divisions[i].TPSentenceOne,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.divisions[i].TPSentenceTwo,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                      ],
                    },
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.divisions[i].IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                    {
                      text: 'Indicator Relevance',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 10, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.divisions[i].IndicatorRelevance,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            } else {
              indicator.push({
                columns: [
                  [
                    {
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.divisions[i].IndicatorPhase === 'Phase A'
                          ? 'phaseAFrame'
                          : this.divisions[i].IndicatorPhase === 'Phase B'
                            ? 'phaseBFrame'
                            : this.divisions[i].IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.divisions[i].IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.divisions[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                    {
                      text: this.divisions[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.divisions[i].TPSentenceOne,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.divisions[i].TPSentenceTwo,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                      ],
                    },
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.divisions[i].IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            }
            divisions.push(indicator);
          }
        } //end divisions

        {
          //start divisions
          var companyToDivisions = [];
          for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
            var division = [
              {
                pageBreak: 'before',
                text: this.apiResponse.RoCDivPages[i].PageTitle,
                alignment: 'center',
                fontSize: 14,
                bold: true,
              },
              {
                text:
                  this.apiResponse.RoCDivPages[i].OtherMetric +
                  ' Rates-of-Change',
                alignment: 'center',
                fontSize: 10,
                margin: [0, 0, 0, 0],
              },
            ];

            var divData = {
              columnGap: 10,
              columns: [
                {
                  // image: await this.$refs.companyToDivision[i].pushToImage(800, 500),
                  image: $('#companyToDivisionChart' + i + 'ChartImg').attr(
                    'src'
                  ),
                  width: 600,
                  height: 400,
                },
                [
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherSeriesName,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    width: 180,
                    // height: 100,
                    alignment: 'center',
                    margin: [0, 0, 0, 30],
                    image:
                      this.apiResponse.RoCDivPages[i].OtherPhase === 'A'
                        ? 'phaseAFrame'
                        : this.apiResponse.RoCDivPages[i].OtherPhase === 'B'
                          ? 'phaseBFrame'
                          : this.apiResponse.RoCDivPages[i].OtherPhase === 'C'
                            ? 'phaseCFrame'
                            : this.apiResponse.RoCDivPages[i].OtherPhase === 'D'
                              ? 'phaseDFrame'
                              : 'phaseNAFrame',
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].SubjectLabel,
                    alignment: 'center',
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].SubjectLastData,
                    alignment: 'center',
                    color: '#183961',
                    bold: true,
                    fontSize: 16,
                    margin: [0, 0, 0, 30],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherLabel,
                    alignment: 'center',
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherLastData,
                    alignment: 'center',
                    color: '#EB6F2D',
                    bold: true,
                    fontSize: 16,
                    margin: [0, 0, 0, 30],
                  },
                ],
              ],
            };

            //add chart image
            division.push(divData);

            companyToDivisions.push(division);
          }
        } //end divisions

        {
          //indicators
          var indicators = [];
          for (let i = 0; i < this.indicators.length; ++i) {
            var indicator = [
              {
                text: '',
                pageBreak: 'before',
              },
            ];
            if (
              this.indicators[i].Headline !== null &&
              this.indicators[i].Headline !== ''
            ) {
              indicator.push({
                table: {
                  widths: ['*'],
                  header: 1,
                  alignment: 'center',
                  body: [
                    [
                      {
                        text: this.indicators[i].Headline,
                        fillColor:
                          this.preview && this.indicators[i].HeadlineIsProofed
                            ? 'yellow'
                            : '',
                        alignment: 'center',
                        fontSize: 12,
                        bold: true,
                      },
                    ],
                  ],
                },
                layout: {
                  hLineColor: function () {
                    return '#09A684';
                  },
                  vLineColor: function () {
                    return '#09A684';
                  },
                  paddingLeft: function () {
                    return 20;
                  },
                  paddingRight: function () {
                    return 20;
                  },
                  paddingTop: function () {
                    return 5;
                  },
                  paddingBottom: function () {
                    return 5;
                  },
                },
                margin: [0, -35, 0, 0],
              });
            }

            var indicatorNotesTable = {
              table: {
                widths: ['*'],
                body: [],
              },
              layout: {
                hLineWidth: function (i, node) {
                  var notesLenght = node.table.body.length;
                  return i === notesLenght ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                paddingLeft: function (i, node) {
                  return 30;
                },
                paddingTop: function (i, node) {
                  return 0;
                },
                paddingBottom: function (i, node) {
                  return 1;
                },
              },
            };

            var indicatorNotes = [];

            for (var x = 0; x < this.indicators[i].ExtraNotes.length; x++) {
              if (this.indicators[i].ExtraNotes[x].includes('<a href='))
                continue;

              indicatorNotes.push([
                {
                  text: [
                    this.indicators[i].ExtraNotes.length > 0
                      ? { text: 'Note: ', bold: true }
                      : '',
                    this.indicators[i].ExtraNotes.length > 0
                      ? this.indicators[i].ExtraNotes[x]
                      : '',
                  ],
                  fontSize: 8,
                },
              ]);
            }

            indicatorNotes.push([
              {
                text: [
                  this.indicators[i].OnDemandLink
                    ? 'Complete Indicator Analysis: '
                    : '',
                  {
                    text: this.indicators[i].OnDemandLink ? 'ITR onDemand' : '',
                    link: this.indicators[i].OnDemandLink,
                    bold: true,
                    decoration: 'underline',
                    color: '#0000ff',
                  },
                ],
                fontSize: 8,
              },
            ]);

            indicatorNotesTable.table.body = indicatorNotes;

            indicator.push(
              {
                text: this.indicators[i].ChartTitle,
                fontSize: chartTitleFontSize,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                // image: await this.$refs.indicator[i].pushToImage(800, 500),
                image: $('#indicatorChart' + i + 'ChartImg').attr('src'),
                width: 600,
                height: 325,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              indicatorNotesTable
            );

            var indicatorTable = {
              layout: 'lightHorizontalLines',
              fontSize: 10,
              margin: [-60, 0, 0, 10],
              table: {
                headerRows: 1,
                widths: [],
                body: [],
              },
            };

            //push table widths and build headers
            let indicatorTableHeaders = [];
            if (this.indicators[i].IndicatorPhaseTable !== null) {
              for (
                let x = 0;
                x < this.indicators[i].IndicatorPhaseTable.Columns.length;
                ++x
              ) {
                if (x === 0) indicatorTable.table.widths.push('*');
                else indicatorTable.table.widths.push('auto');

                let row = {
                  text: this.indicators[i].IndicatorPhaseTable.Columns[x]
                    .MonthYear,
                  alignment: 'center',
                };
                indicatorTableHeaders.push(row);
              }
            }

            //add table data
            indicatorTable.table.body.push(indicatorTableHeaders);

            //add row data
            var indicatorTableData = [];
            if (this.indicators[i].IndicatorPhaseTable !== null) {
              for (
                let x = 0;
                x < this.indicators[i].IndicatorPhaseTable.Columns.length;
                ++x
              ) {
                const phase =
                  this.indicators[i].IndicatorPhaseTable.Columns[x].Phase;
                indicatorTableData.push({
                  text: phase,
                  alignment: 'center',
                  style:
                    phase === 'A'
                      ? 'phaseA'
                      : phase === 'B'
                        ? 'phaseB'
                        : phase === 'C'
                          ? 'phaseC'
                          : phase === 'D'
                            ? 'phaseD'
                            : 'defaultTableTextColor',
                });
              }
            }
            indicatorTable.table.body.push(indicatorTableData);

            // add chart image
            if (this.indicators[i].IndicatorRelevance) {
              indicator.push({
                columns: [
                  [
                    {
                      // fit: [100, 100],
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.indicators[i].IndicatorPhase === 'Phase A'
                          ? 'phaseAFrame'
                          : this.indicators[i].IndicatorPhase === 'Phase B'
                            ? 'phaseBFrame'
                            : this.indicators[i].IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.indicators[i].IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.indicators[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                    {
                      text: this.indicators[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.indicators[i].TPSentenceOne,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.indicators[i].TPSentenceTwo,
                          fontSize: 10,
                          margin: [-60, 0, 0, 10],
                        },
                      ],
                    },
                    indicatorTable,
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.indicators[i].IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                    {
                      text: 'Indicator Relevance',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 10, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.indicators[i].IndicatorRelevance,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            } else {
              indicator.push({
                columns: [
                  [
                    {
                      // fit: [100, 100],
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.indicators[i].IndicatorPhase === 'Phase A'
                          ? 'phaseAFrame'
                          : this.indicators[i].IndicatorPhase === 'Phase B'
                            ? 'phaseBFrame'
                            : this.indicators[i].IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.indicators[i].IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.indicators[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                    {
                      text: this.indicators[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.indicators[i].TPSentenceOne,
                          fontSize: 10,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.indicators[i].TPSentenceTwo,
                          fontSize: 10,
                          margin: [-60, 0, 0, 10],
                        },
                      ],
                    },
                    indicatorTable,
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.indicators[i].IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            }
            indicators.push(indicator);
          }
        } //end indicators

        {
          //start multiData
          var multiData = [];
          for (
            let i = 0;
            i < this.apiResponse.MultidataComparisonPages.length;
            ++i
          ) {
            var multiDataPage = [
              {
                pageBreak: 'before',
                text: this.apiResponse.MultidataComparisonPages[i].ChartTitle,
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                // image: await this.$refs.multiData[i].pushToImage(),
                image: $('#multiDataChart' + i + 'ChartImg').attr('src'),
                height: 500,
                width: 650,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
            ];

            multiData.push(multiDataPage);
          }
        } //end multiData

        {
          //start com market indicator
          var comIndicators = [];
          for (let i = 0; i < this.apiResponse.CoMIIndPages.length; ++i) {
            var comIndicator = [
              {
                text: '',
                pageBreak: 'before',
              },
            ];

            if (
              this.apiResponse.CoMIIndPages[i].Headline !== null &&
              this.apiResponse.CoMIIndPages[i].Headline !== ''
            ) {
              comIndicator.push({
                table: {
                  widths: ['*'],
                  header: 1,
                  alignment: 'center',
                  body: [
                    [
                      {
                        text: this.apiResponse.CoMIIndPages[i].Headline,
                        fillColor:
                          this.preview &&
                          this.apiResponse.CoMIIndPages[i].HeadlineIsProofed
                            ? 'yellow'
                            : '',
                        alignment: 'center',
                        fontSize: 12,
                        bold: true,
                      },
                    ],
                  ],
                },
                layout: {
                  hLineColor: function (i, node) {
                    return '#09A684';
                  },
                  vLineColor: function (i, node) {
                    return '#09A684';
                  },
                  paddingLeft: function (i, node) {
                    return 20;
                  },
                  paddingRight: function (i, node) {
                    return 20;
                  },
                  paddingTop: function (i, node) {
                    return 5;
                  },
                  paddingBottom: function (i, node) {
                    return 5;
                  },
                },
                margin: [0, -25, 0, 0],
              });
            }

            var comMIIndicatorNotesTable = {
              table: {
                widths: ['*'],
                body: [],
              },
              layout: {
                hLineWidth: function (i, node) {
                  var notesLenght = node.table.body.length;
                  return i === notesLenght ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                paddingLeft: function (i, node) {
                  return 30;
                },
                paddingTop: function (i, node) {
                  return 0;
                },
                paddingBottom: function (i, node) {
                  return 1;
                },
              },
            };

            var comIndicatorNotes = [];

            for (
              var x = 0;
              x < this.apiResponse.CoMIIndPages[i].ExtraNotes.length;
              x++
            ) {
              if (
                this.apiResponse.CoMIIndPages[i].ExtraNotes[x].includes(
                  '<a href='
                )
              )
                continue;

              comIndicatorNotes.push([
                {
                  text: [
                    this.apiResponse.CoMIIndPages[i].ExtraNotes.length > 0
                      ? { text: 'Note: ', bold: true }
                      : '',
                    this.apiResponse.CoMIIndPages[i].ExtraNotes.length > 0
                      ? this.apiResponse.CoMIIndPages[i].ExtraNotes[x]
                      : '',
                  ],
                  fontSize: 8,
                },
              ]);
            }

            comIndicatorNotes.push([
              {
                text: [
                  this.apiResponse.CoMIIndPages[i].OnDemandLink
                    ? 'Complete Indicator Analysis: '
                    : '',
                  {
                    text: this.apiResponse.CoMIIndPages[i].OnDemandLink
                      ? 'ITR onDemand'
                      : '',
                    link: this.apiResponse.CoMIIndPages[i].OnDemandLink,
                    bold: true,
                    decoration: 'underline',
                    color: '#0000ff',
                  },
                ],
                fontSize: 8,
              },
            ]);

            comMIIndicatorNotesTable.table.body = comIndicatorNotes;
            comIndicator.push(
              {
                text: this.apiResponse.CoMIIndPages[i].ChartTitle,
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                // image: await this.$refs.dataMarketIndicator[i].pushToImage(800, 500),
                image: $('#marketIndicator' + i + 'ChartImg').attr('src'),
                width: 600,
                height: 325,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              comMIIndicatorNotesTable
            );

            var comIndicatorTable = {
              layout: 'lightHorizontalLines',
              fontSize: 10,
              margin: [-60, 0, 0, 10],
              table: {
                headerRows: 1,
                widths: [],
                body: [],
              },
            };

            //push table widths and build headers
            let comIndicatorTableHeaders = [];
            if (this.apiResponse.CoMIIndPages[i].IndicatorPhaseTable.Columns) {
              for (
                let x = 0;
                x <
                this.apiResponse.CoMIIndPages[i].IndicatorPhaseTable.Columns
                  .length;
                ++x
              ) {
                if (x === 0) comIndicatorTable.table.widths.push('*');
                else comIndicatorTable.table.widths.push('auto');

                let row = {
                  text: this.apiResponse.CoMIIndPages[i].IndicatorPhaseTable
                    .Columns[x].MonthYear,
                  alignment: 'center',
                };
                comIndicatorTableHeaders.push(row);
              }

              //add table data
              comIndicatorTable.table.body.push(comIndicatorTableHeaders);

              //add row data
              var comIndicatorTableData = [];
              for (
                let x = 0;
                x <
                this.apiResponse.CoMIIndPages[i].IndicatorPhaseTable.Columns
                  .length;
                ++x
              ) {
                const phase =
                  this.apiResponse.CoMIIndPages[i].IndicatorPhaseTable.Columns[
                    x
                  ].Phase;
                comIndicatorTableData.push({
                  text: phase,
                  alignment: 'center',
                  style:
                    phase === 'A'
                      ? 'phaseA'
                      : phase === 'B'
                        ? 'phaseB'
                        : phase === 'C'
                          ? 'phaseC'
                          : phase === 'D'
                            ? 'phaseD'
                            : 'defaultTableTextColor',
                });
              }

              comIndicatorTable.table.body.push(comIndicatorTableData);
            }

            // add chart image
            if (
              this.apiResponse.CoMIIndPages[i].IndicatorRelevance &&
              this.apiResponse.CoMIIndPages[i].IndicatorRelevance.length > 0
            ) {
              comIndicator.push({
                // columnGap: 30,
                columns: [
                  [
                    {
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.apiResponse.CoMIIndPages[i].IndicatorPhase ===
                        'Phase A'
                          ? 'phaseAFrame'
                          : this.apiResponse.CoMIIndPages[i].IndicatorPhase ===
                              'Phase B'
                            ? 'phaseBFrame'
                            : this.apiResponse.CoMIIndPages[i]
                                  .IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.apiResponse.CoMIIndPages[i]
                                    .IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.apiResponse.CoMIIndPages[i].TPSentenceOne,
                          fontSize: 8,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.apiResponse.CoMIIndPages[i].TPSentenceTwo,
                          fontSize: 8,
                          margin: [-60, 0, 0, 5],
                        },
                      ],
                    },
                    comIndicatorTable,
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i]
                        .IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                    {
                      text: 'Indicator Relevance',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 10, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i].IndicatorRelevance,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            } else {
              comIndicator.push({
                // columnGap: 30,
                columns: [
                  [
                    {
                      width: 150,
                      // height: 100,
                      // alignment: 'center',
                      margin: [0, 5, 0, 0],
                      image:
                        this.apiResponse.CoMIIndPages[i].IndicatorPhase ===
                        'Phase A'
                          ? 'phaseAFrame'
                          : this.apiResponse.CoMIIndPages[i].IndicatorPhase ===
                              'Phase B'
                            ? 'phaseBFrame'
                            : this.apiResponse.CoMIIndPages[i]
                                  .IndicatorPhase === 'Phase C'
                              ? 'phaseCFrame'
                              : this.apiResponse.CoMIIndPages[i]
                                    .IndicatorPhase === 'Phase D'
                                ? 'phaseDFrame'
                                : 'phaseNAFrame',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i].LeadLagLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i].CorrelLabel,
                      // alignment: 'center',
                      fontSize: 10,
                      margin: [0, 0, 50, 5],
                      width: 'auto',
                    },
                  ],
                  [
                    {
                      text: 'Turning Point Analysis',
                      fontSize: 10,
                      bold: true,
                      margin: [-60, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      width: 'auto',
                      ul: [
                        {
                          text: this.apiResponse.CoMIIndPages[i].TPSentenceOne,
                          fontSize: 8,
                          margin: [-60, 0, 0, 5],
                        },
                        {
                          text: this.apiResponse.CoMIIndPages[i].TPSentenceTwo,
                          fontSize: 8,
                          margin: [-60, 0, 0, 5],
                        },
                      ],
                    },
                    comIndicatorTable,
                  ],
                  [
                    {
                      text: 'Current Indicator Amplitude',
                      fontSize: 10,
                      bold: true,
                      margin: [10, 5, 0, 5],
                      width: 'auto',
                    },
                    {
                      text: this.apiResponse.CoMIIndPages[i]
                        .IndicatorCurrentAmp,
                      fontSize: 10,
                      margin: [10, 0, 20, 5],
                      width: 'auto',
                    },
                  ],
                ],
              });
            }

            comIndicators.push(comIndicator);
          }
        } //end com market indicator

        {
          //forecast history
          if (this.apiResponse.FCHistoryPage !== null) {
            var forecastHistoryPage = [
              {
                pageBreak: 'before',
                columnGap: 5,
                columns: [
                  {
                    fit: [100, 100],
                    image: 'itrLogo',
                  },
                  {
                    width: '*',
                    alignment: 'center',
                    fontSize: 12,
                    bold: true,
                    text: [this.apiResponse.FCHistoryPage.PageTitle],
                  },
                  {
                    fit: [100, 100],
                    alignment: 'right',
                    image: companyLogoImageDataUrl,
                  },
                ],
              },
            ];

            var wasRevised1ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Rates-of-Change Adjusted'
            ) {
              wasRevised1ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Data Trends Adjusted'
            ) {
              wasRevised1ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Forecast Revised'
            ) {
              wasRevised1ID = 'forecastRevisedBar';
            }

            var wasRevised2ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Rates-of-Change Adjusted'
            ) {
              wasRevised2ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Data Trends Adjusted'
            ) {
              wasRevised2ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Forecast Revised'
            ) {
              wasRevised2ID = 'forecastRevisedBar';
            }

            var wasRevised3ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 &&
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
                'Rates-of-Change Adjusted'
            ) {
              wasRevised3ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
              'Data Trends Adjusted'
            ) {
              wasRevised3ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
              'Forecast Revised'
            ) {
              wasRevised3ID = 'forecastRevisedBar';
            }

            var forecastHistoryTable = {
              layout: 'lightHorizontalLines',
              margin: [0, 10, 0, 10],
              fontSize: 8,
              table: {
                headerRows: 1,
                alignment: 'center',
                widths: [],
                body: [],
              },
            };

            {
              // widths start
              var widths = ['*', '*'];
              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              forecastHistoryTable.table.widths = widths;
            } // widths end

            {
              // body start
              var body = [
                {
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                },
                {
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header1,
                  alignment: 'center',
                },
              ];

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header2,
                alignment: 'center',
              });

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header3,
                alignment: 'center',
              });

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header4,
                alignment: 'center',
              });

              forecastHistoryTable.table.body.push(body);
            } // body end

            for (
              let i = 0;
              i < this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length;
              i++
            ) {
              const row = this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i];
              var index = i;
              var actuals = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FirstColumn
              );
              var lowerRange = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FirstColumn
              );
              var upperRange = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FirstColumn
              );
              var actualsSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .SecondColumn
              );
              var lowerRangeSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .SecondColumn
              );
              var upperRangeSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .SecondColumn
              );
              var actualsThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .ThirdColumn
              );
              var lowerRangeThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .ThirdColumn
              );
              var upperRangeThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .ThirdColumn
              );
              var actualsFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FourthColumn
              );
              var lowerRangeFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FourthColumn
              );
              var upperRangeFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FourthColumn
              );

              var fcRow = [
                {
                  text: row.RowTitle,
                  bold: true,
                },
              ];

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.FirstColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actuals >= lowerRange && actuals <= upperRange
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.FirstColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised1ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.SecondColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsSecond >= lowerRangeSecond &&
                    actualsSecond <= upperRangeSecond
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.SecondColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised2ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.ThirdColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsThird >= lowerRangeThird &&
                    actualsThird <= upperRangeThird
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.ThirdColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised3ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.FourthColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsFourth >= lowerRangeFourth &&
                    actualsFourth <= upperRangeFourth
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.FourthColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              forecastHistoryTable.table.body.push(fcRow);

              //push empty row if needed
              if (i === 4 || i === 9 || (i > 10 && row.RowTitle === 'Actual')) {
                var emptyRow = [
                  {
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  },
                  {
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  },
                ];

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                forecastHistoryTable.table.body.push(emptyRow);
              }
            }

            forecastHistoryPage.push(forecastHistoryTable);

            var revisionHistoryText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Forecast Revision History:',
                      fillColor: '#183961',
                      color: '#FFF',
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#183961';
                },
                vLineColor: function () {
                  return '#183961';
                },
              },
            };

            var revisionUL = [];
            for (
              let i = 0;
              i < this.apiResponse.FCHistoryPage.ForecastRevisions.length;
              i++
            ) {
              const element =
                this.apiResponse.FCHistoryPage.ForecastRevisions[i];
              revisionUL.push(element);
            }

            revisionHistoryText.table.body.push([
              {
                ul: revisionUL,
              },
            ]);
            forecastHistoryPage.push(revisionHistoryText);
          }
        } //forecast history end

        // //guide
        var pdfGuide = [
          {
            pageBreak: 'before',
            image: 'guidePage',
            width: 900,
            alignment: 'center',
            margin: [0, -110, 0, 50],
          },
        ];

        // // terminology and methodology
        var termAndMethodology = [
          {
            pageBreak: 'before',
            image: 'termMethodology',
            width: 900,
            alignment: 'center',
            margin: [0, -100, 0, 50],
          },
        ];

        //indicator def
        var indicatorDefinitions = [
          {
            pageBreak: 'before',
            table: {
              widths: ['*'],
              header: 1,
              body: [
                [
                  {
                    text: 'Indicator Definitions',
                    color: '#FFF',
                    fillColor: '#3075A4',
                    alignment: 'center',
                    fontSize: 14,
                    bold: true,
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return '#3075A4';
              },
              vLineColor: function () {
                return '#3075A4';
              },
              paddingLeft: function () {
                return 40;
              },
              paddingRight: function () {
                return 40;
              },
              paddingTop: function () {
                return 5;
              },
              paddingBottom: function () {
                return 5;
              },
            },
            // fontSize: 14,
            // style: 'blueBarWText',
            // alignment: 'center'
          },
        ];

        var indicatorDefinitionsTable = {
          fontSize: 10,
          margin: [0, 0, 0, 10],
          table: {
            widths: ['*', '*'],
            body: [],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex % 2 === 0 ? '#b8cce4' : null;
            },
            hLineWidth: function () {
              return 1;
            },
            vLineWidth: function () {
              return 1;
            },
          },
        };

        //loop through definitions and add
        for (
          let i = 0;
          i <
          this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
            .length;
          ++i
        ) {
          var row =
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i];

          indicatorDefinitionsTable.table.body.push([
            { text: row.Name, margin: [0, 5, 0, 5] },
            { text: row.Definition, margin: [0, 5, 0, 5] },
          ]);
        }

        indicatorDefinitions.push(indicatorDefinitionsTable);

        //make pdf
        var docDefinition = {
          pageOrientation: 'landscape',
          info: {
            title: this.apiResponse.companyName,
          },
          content: [coverPage],
          footer: (currentPage, pageCount) => {
            return {
              margin: [40, 20, 40, 0],
              columns: [
                {
                  text:
                    (currentPage === 1
                      ? document.getElementById('copyright').innerHTML +
                        this.currentYear
                      : '') +
                    ' ITR Economics' +
                    document.getElementById('tradeMark').innerHTML,
                  fontSize: 8,
                },
                {
                  text: this.apiResponse.CoverPage.ProductType,
                  fontSize: 8,
                  alignment: 'right',
                },
              ],
            };
          },
          styles: {
            blueBar: {
              background: '#3075A4',
              color: '#3075A4',
            },
            blueBarWText: {
              background: '#3075A4',
              color: '#FFF',
            },
            phaseA: {
              color: '#0A42D3',
              bold: true,
            },
            phaseB: {
              color: '#44AC4E',
              bold: true,
            },
            phaseC: {
              color: '#FF9916',
              bold: true,
            },
            phaseD: {
              color: '#D2232A',
              bold: true,
            },
            defaultTableTextColor: {
              color: '#A7A9AB',
              bold: true,
            },
            darkBlue: {
              color: '#2c4a6f',
            },
          },
          images: {
            pdfphaseAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseA.png',
            pdfphaseBFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseB.png',
            pdfphaseCFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseC.png',
            pdfphaseDFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseD.png',
            phaseAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-frame.png',
            phaseBFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-b-frame.png',
            phaseCFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-c-frame.png',
            phaseDFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-d-frame.png',
            phaseNAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-frame.png',
            phaseAFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-full.png',
            phaseBFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-b-full.png',
            phaseCFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-c-full.png',
            phaseDFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-d-full.png',
            guidePage:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/evp-add-ons-guide.png',
            termMethodology:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/terminology-methodology.png',
            managementObjectives:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/management-objectives.png',
            itrLogo:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/logos/new/itr-corporate-logo-color-no-white-space.png',
          },
        };

        var pagesUsed = [];
        for (var y = 0; y < this.apiResponse.PageOrder.length; y++) {
          if (
            this.apiResponse.PageOrder[y].Value.includes('multi-data') &&
            !pagesUsed.includes('multi-data')
          ) {
            docDefinition.content.push(multiData);
            pagesUsed.push('multi-data');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes(
              'indicator-definitions'
            ) &&
            !pagesUsed.includes('indicator-definitions')
          ) {
            docDefinition.content.push(indicatorDefinitions);
            pagesUsed.push('indicator-definitions');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('indicator') &&
            !pagesUsed.includes('indicator')
          ) {
            docDefinition.content.push(indicators);
            pagesUsed.push('indicator');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('division') &&
            !pagesUsed.includes('division')
          ) {
            docDefinition.content.push(divisions);
            pagesUsed.push('division');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('companyToDivision') &&
            !pagesUsed.includes('companyToDivision')
          ) {
            docDefinition.content.push(companyToDivisions);
            pagesUsed.push('companyToDivision');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes(
              'dataMarketIndicator'
            ) &&
            !pagesUsed.includes('dataMarketIndicator')
          ) {
            docDefinition.content.push(comIndicators);
            pagesUsed.push('dataMarketIndicator');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('forecast') &&
            !pagesUsed.includes('forecast')
          ) {
            docDefinition.content.push(forecastPage);
            pagesUsed.push('forecast');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('forecast-history') &&
            !pagesUsed.includes('forecast-history')
          ) {
            docDefinition.content.push(forecastHistoryPage);
            pagesUsed.push('forecast-history');
          }
        }

        // docDefinition.content.push(pdfGuide);
        // docDefinition.content.push(termAndMethodology);

        var pdf = pdfMake.createPdf(docDefinition);
        if (this.preview) {
          pdf.open();
        } else {
          pdf.download(this.companyName + '.pdf');
        }

        setTimeout(function () {
          $('#loadingFileModal').modal('hide');
        }, 5000);
      },
      async downloadPPT() {
        let pres = new pptxgen();
        const companyLogoImageDataUrl = await this.getReportLogo();

        var companyName = this.apiResponse.CompanyName;

        let companyNameFontSize = 42;
        if (companyName.length >= 70) {
          companyNameFontSize = 10;
        } else if (companyName.length >= 40) {
          companyNameFontSize = 12;
        } else if (companyName.length >= 20) {
          companyNameFontSize = 22;
        } else if (companyName.length >= 15) {
          companyNameFontSize = 32;
        }

        // this.apiResponse.FCHistoryPage.PageTitle
        let fcHistoryTitleFontSize = 42;
        if (this.apiResponse.FCHistoryPage !== null) {
          if (this.apiResponse.FCHistoryPage.PageTitle.length >= 70) {
            fcHistoryTitleFontSize = 10;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 40) {
            fcHistoryTitleFontSize = 12;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 20) {
            fcHistoryTitleFontSize = 22;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 15) {
            fcHistoryTitleFontSize = 32;
          }
        }

        {
          // Master Slide Start
          pres.defineSlideMaster({
            title: 'MASTER_SLIDE',
            background: { color: 'FFFFFF' },
            margin: '2',
            objects: [
              {
                image: {
                  w: '99%',
                  h: '100%',
                  y: '0%',
                  x: '1%',
                  data: this.getBase64Image(
                    document.getElementById('pptFooter')
                  ),
                },
              },
            ],
          });
        } // Master Slide End

        {
          // Cover Page Start
          let coverPageSlide = pres.addSlide();

          coverPageSlide.addImage({
            data: this.getBase64Image(
              document.getElementById('pptCoverBackground')
            ),
            h: '100%',
            w: '100%',
            y: '0%',
            x: '0%',
          });

          if (companyLogoImageDataUrl) {
            coverPageSlide.addImage({
              data: companyLogoImageDataUrl,
              w: '25%',
              h: '25%',
              y: '5%',
              x: '50%',
              sizing: { type: 'cover' },
            });
          }

          coverPageSlide.addText(companyName, {
            x: '33%',
            y: '40%',
            w: '65%',
            fontFace: 'Calibri',
            fontSize: companyNameFontSize,
            bold: true,
            color: '13355e',
            align: 'right',
          });

          coverPageSlide.addText(this.apiResponse.CoverPage.ProductType, {
            x: '23%',
            y: '56%',
            fontFace: 'Calibri',
            fontSize: '35',
            bold: true,
            color: '13355e',
            align: 'right',
          });

          coverPageSlide.addText(
            [
              {
                text: 'www.itrondemand.com',
                options: { hyperlink: { url: 'https://www.itrondemand.com' } },
              },
            ],
            {
              x: '56%',
              y: '70%',
              fontFace: 'Calibri',
              fontSize: '30',
              color: '13355e',
            }
          );

          coverPageSlide.addText('603.796.2500 • reports@itreconomics.com', {
            x: '45%',
            y: '91%',
            fontFace: 'Calibri',
            fontSize: '12',
            color: '13355e',
            align: 'center',
          });

          coverPageSlide.addText(
            '©' +
              ' ' +
              this.currentYear +
              ' ' +
              'ITR Economics' +
              document.getElementById('tradeMark').innerHTML +
              ' ' +
              'All Rights Reserved',
            {
              x: '45%',
              y: '94%',
              fontFace: 'Calibri',
              fontSize: '12',
              color: '13355e',
              align: 'center',
            }
          );
        } // Cover Page End

        var pagesUsed = [];
        for (var y = 0; y < this.apiResponse.PageOrder.length; y++) {
          if (
            this.apiResponse.PageOrder[y].Value.includes('multi-data') &&
            !pagesUsed.includes('multi-data')
          ) {
            {
              // MultiData Start
              for (
                let i = 0;
                i < this.apiResponse.MultidataComparisonPages.length;
                ++i
              ) {
                let multiDataSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });

                multiDataSlide.addText(
                  this.apiResponse.MultidataComparisonPages[i].Headline,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: '18',
                    fontFace: 'Calibri',
                    color: '386092',
                    bold: true,
                    y: '5%',
                  }
                );

                multiDataSlide.addText(
                  this.apiResponse.MultidataComparisonPages[i].ChartTitle,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: '14',
                    fontFace: 'Calibri',
                    y: '10%',
                  }
                );

                let multichart_img = $('#multiDataChart' + i + 'ChartImg').attr(
                  'src'
                );
                multiDataSlide.addImage({
                  data: multichart_img,
                  h: '70%',
                  w: '70%',
                  align: 'center',
                  y: '15%',
                  x: '15%',
                });
              }
            } // MultiData End
            pagesUsed.push('multi-data');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('indicator') &&
            !pagesUsed.includes('indicator')
          ) {
            {
              // Leading Indicators Start
              for (let i = 0; i < this.indicators.length; ++i) {
                let leadingIndicatorSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });

                leadingIndicatorSlide.addText(this.indicators[i].Headline, {
                  w: '100%',
                  align: 'center',
                  fontSize: '16',
                  fontFace: 'Calibri',
                  color: '386092',
                  bold: true,
                  y: '5%',
                });

                leadingIndicatorSlide.addText(this.indicators[i].ChartTitle, {
                  w: '100%',
                  align: 'center',
                  fontSize: 10,
                  fontFace: 'Calibri',
                  y: '10%',
                });

                let indicator_img = $('#indicatorChart' + i + 'ChartImg').attr(
                  'src'
                );
                leadingIndicatorSlide.addImage({
                  data: indicator_img,
                  h: '70%',
                  w: '70%',
                  align: 'center',
                  y: '15%',
                  x: '15%',
                });
              }
            } // Leading Indicators End
            pagesUsed.push('indicator');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('division') &&
            !pagesUsed.includes('division')
          ) {
            {
              // Division Start
              for (let i = 0; i < this.divisions.length; ++i) {
                let leadingIndicatorSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });

                leadingIndicatorSlide.addText(this.divisions[i].Headline, {
                  w: '100%',
                  align: 'center',
                  fontSize: '18',
                  fontFace: 'Calibri',
                  color: '386092',
                  bold: true,
                  y: '5%',
                });

                leadingIndicatorSlide.addText(this.divisions[i].ChartTitle, {
                  w: '100%',
                  align: 'center',
                  fontSize: '14',
                  fontFace: 'Calibri',
                  y: '10%',
                });

                let division_img = $('#divisionChart' + i + 'ChartImg').attr(
                  'src'
                );
                leadingIndicatorSlide.addImage({
                  data: division_img,
                  h: '70%',
                  w: '70%',
                  align: 'center',
                  y: '15%',
                  x: '15%',
                });
              }
            } // divisions End
            pagesUsed.push('division');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('companyToDivision') &&
            !pagesUsed.includes('companyToDivision')
          ) {
            {
              // ROC Start
              for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
                let dataMarketSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });

                dataMarketSlide.addText(
                  this.apiResponse.RoCDivPages[i].PageTitle,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: '18',
                    fontFace: 'Calibri',
                    color: '386092',
                    bold: true,
                    y: '5%',
                  }
                );

                // dataMarketSlide.addText( this.apiResponse.RoCDivPages[i].SubjectMetric + ' Rates-of-Change', { w: '100%', align: 'center', fontSize: '14', fontFace: 'Calibri', y: '10%' });

                let division_img = $(
                  '#companyToDivisionChart' + i + 'ChartImg'
                ).attr('src');
                dataMarketSlide.addImage({
                  data: division_img,
                  h: '70%',
                  w: '70%',
                  align: 'center',
                  y: '15%',
                  x: '15%',
                });
              }
            } // ROC End
            pagesUsed.push('companyToDivision');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes(
              'dataMarketIndicator'
            ) &&
            !pagesUsed.includes('dataMarketIndicator')
          ) {
            {
              // Company Index Indicators Start
              for (let i = 0; i < this.apiResponse.CoMIIndPages.length; ++i) {
                let leadingIndicatorSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });

                leadingIndicatorSlide.addText(
                  this.apiResponse.CoMIIndPages[i].Headline,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: '16',
                    fontFace: 'Calibri',
                    color: '386092',
                    bold: true,
                    y: '5%',
                  }
                );

                leadingIndicatorSlide.addText(
                  this.apiResponse.CoMIIndPages[i].ChartTitle,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: 10,
                    fontFace: 'Calibri',
                    y: '10%',
                  }
                );

                let indicator_img = $('#marketIndicator' + i + 'ChartImg').attr(
                  'src'
                );
                leadingIndicatorSlide.addImage({
                  data: indicator_img,
                  h: '70%',
                  w: '70%',
                  align: 'center',
                  y: '15%',
                  x: '15%',
                });
              }
            } // Leading Indicators End
            pagesUsed.push('dataMarketIndicator');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('forecast') &&
            !pagesUsed.includes('forecast')
          ) {
            {
              // Forecast Start
              if (this.forecastData !== null) {
                let forecastSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });
                forecastSlide.addText(
                  this.forecastData.TableTitle + ' Forecast',
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: 10,
                    fontFace: 'Calibri',
                    color: '386092',
                    bold: true,
                    y: '5%',
                  }
                );

                let forecastTableHeaders = [];
                for (
                  let i = 0;
                  i < this.forecastData.ForecastTable.Headers.length;
                  ++i
                ) {
                  if (this.forecastData.HideFirstColumn && i === 1) {
                    if (
                      (i === 1 && this.forecastData.ForecastRevised) ||
                      (this.monthEnd[i] ===
                        this.forecastData.FiscalYearEndMonth &&
                        this.forecastData.ForecastTable.Headers.length - 1 !==
                          i)
                    ) {
                      forecastTableHeaders.push({
                        text: '',
                      });
                    }
                  } else {
                    let row = {
                      text: this.forecastData.ForecastTable.Headers[i],
                      options: {
                        align: i === 0 ? 'left' : 'center',
                        bold: true,
                        fontSize: 6,
                      },
                    };
                    forecastTableHeaders.push(row);

                    if (
                      (i === 1 && this.forecastData.ForecastRevised) ||
                      (this.monthEnd[i] ===
                        this.forecastData.FiscalYearEndMonth &&
                        this.forecastData.ForecastTable.Headers.length - 1 !==
                          i)
                    ) {
                      forecastTableHeaders.push({
                        text: '',
                        options: { fontSize: 6 },
                      });
                    }
                  }
                }

                let rows = [];

                rows.push(forecastTableHeaders);

                // add row data
                for (
                  let i = 0;
                  i < this.forecastData.ForecastTable.Rows.length;
                  ++i
                ) {
                  var fillColor = '';
                  if (i === 1 || i === 5 || i === 9) {
                    fillColor = 'f2f2f2';
                  } else if (
                    this.forecastData.ForecastTable.Rows.length === 14 &&
                    i === 12
                  ) {
                    fillColor = 'f2f2f2';
                  } else if (
                    this.forecastData.ForecastTable.Rows.length > 14 &&
                    i === 13
                  ) {
                    fillColor = 'f2f2f2';
                  }

                  var boldRow = false;
                  if (
                    (i === 1) | (i === 3) ||
                    i === 5 ||
                    i === 7 ||
                    i === 9 ||
                    i === 11
                  ) {
                    boldRow = true;
                  } else if (
                    (this.forecastData.ForecastTable.Rows.length === 14 &&
                      i === 12) ||
                    (this.forecastData.ForecastTable.Rows.length === 14 &&
                      i === 13)
                  ) {
                    boldRow = true;
                  } else if (
                    (this.forecastData.ForecastTable.Rows.length > 14 &&
                      i === 13) ||
                    (this.forecastData.ForecastTable.Rows.length > 14 &&
                      i === 15)
                  ) {
                    boldRow = true;
                  }

                  var row = [
                    {
                      text: this.forecastData.ForecastTable.Rows[i].RowTitle,
                      options: {
                        align: 'center',
                        fill: fillColor,
                        bold: boldRow,
                        fontSize: 6,
                      },
                    },
                  ];

                  let y = 0;
                  var additionalColumns = 0;
                  for (
                    let x = 0;
                    x <
                    this.forecastData.ForecastTable.Rows[i].ForecastColumns
                      .length;
                    ++x
                  ) {
                    const forecastData =
                      this.forecastData.ForecastTable.Rows[i].ForecastColumns[
                        x
                      ];

                    if (this.forecastData.HideFirstColumn && x === 0) continue;

                    var actuals = parseFloat(
                      this.forecastData.ForecastTable.Rows[7].ForecastColumns[0]
                    );
                    var lowerRange = parseFloat(
                      this.forecastData.ForecastTable.Rows[4].ForecastColumns[0]
                    );
                    var upperRange = parseFloat(
                      this.forecastData.ForecastTable.Rows[6].ForecastColumns[0]
                    );

                    let fill = '';
                    if (i === 1 || i === 5 || i === 9) {
                      fill = 'f2f2f2';
                    } else if (
                      this.forecastData.ForecastTable.Rows.length === 14 &&
                      i === 12
                    ) {
                      fill = 'f2f2f2';
                    } else if (
                      this.forecastData.ForecastTable.Rows.length > 14 &&
                      i === 13
                    ) {
                      fill = 'f2f2f2';
                    }

                    let boldCol = false;
                    if (
                      i === 1 ||
                      i === 3 ||
                      i === 5 ||
                      i === 7 ||
                      i === 9 ||
                      i === 11
                    ) {
                      boldCol = true;
                    } else if (
                      (this.forecastData.ForecastTable.Rows.length === 14 &&
                        i === 12) ||
                      (this.forecastData.ForecastTable.Rows.length === 14 &&
                        i === 13)
                    ) {
                      boldCol = true;
                    } else if (
                      (this.forecastData.ForecastTable.Rows.length > 14 &&
                        i === 13) ||
                      (this.forecastData.ForecastTable.Rows.length > 14 &&
                        i === 15)
                    ) {
                      boldCol = true;
                    }

                    if (
                      (x === 1 && this.forecastData.ForecastRevised) ||
                      (this.monthEnd[x] ===
                        this.forecastData.FiscalYearEndMonth &&
                        this.forecastData.ForecastTable.Headers.length - 1 !==
                          x)
                    ) {
                      row.push({
                        text: '',
                        options: {
                          fill:
                            x === 1 && this.forecastData.ForecastRevised
                              ? ''
                              : fill,
                          fontSize: 6,
                        },
                      });
                      additionalColumns = ++y;
                    }

                    if (i == 3 || i == 7 || i == 11) {
                      row.push({
                        text: forecastData,
                        options: {
                          align: 'center',
                          fontSize: 6,
                          bold: true,
                          color:
                            actuals >= lowerRange && actuals <= upperRange
                              ? '09A684'
                              : 'D2232A',
                        },
                      });
                    } else if (
                      this.forecastData.ForecastTable.Rows.length === 14 &&
                      i === 13
                    ) {
                      row.push({
                        text: forecastData,
                        options: {
                          align: 'center',
                          fontSize: 6,
                          bold: true,
                          color:
                            actuals >= lowerRange && actuals <= upperRange
                              ? '09A684'
                              : 'D2232A',
                        },
                      });
                    } else if (
                      this.forecastData.ForecastTable.Rows.length > 14 &&
                      i === 15
                    ) {
                      row.push({
                        text: forecastData,
                        options: {
                          align: 'center',
                          fontSize: 6,
                          bold: true,
                          color:
                            actuals >= lowerRange && actuals <= upperRange
                              ? '09A684'
                              : 'D2232A',
                        },
                      });
                    } else {
                      row.push({
                        text: forecastData,
                        options: {
                          align: 'center',
                          fontSize: 6,
                          fill: fill,
                          bold: boldCol,
                        },
                      });
                    }
                  }

                  rows.push(row);

                  if (i === 3 || i === 7 || i === 11) {
                    var blankRow = [
                      {
                        text: '',
                        options: {
                          border: { type: 'none' },
                          fontSize: 6,
                        },
                      },
                    ];
                    for (
                      let x = 0;
                      x <
                      this.forecastData.ForecastTable.Rows[i].ForecastColumns
                        .length +
                        additionalColumns;
                      ++x
                    ) {
                      if (this.forecastData.HideFirstColumn && x === 0)
                        continue;

                      blankRow.push({
                        text: '',
                        options: {
                          border: { type: 'none' },
                          fontSize: 6,
                        },
                      });
                    }
                    rows.push(blankRow);
                  }
                }

                let b = 0;
                var simpleAdditionalColumns = 0;
                var blankRowIndex = [];
                for (
                  let x = 0;
                  x < this.forecastData.ForecastTable.Headers.length;
                  ++x
                ) {
                  if (x === 1 && this.forecastData.ForecastRevised) {
                    simpleAdditionalColumns = ++b;
                    blankRowIndex.push(x + simpleAdditionalColumns);
                  } else if (
                    this.monthEnd[x] === this.forecastData.FiscalYearEndMonth &&
                    this.forecastData.ForecastTable.Headers.length - 1 !== x
                  ) {
                    simpleAdditionalColumns = ++b;
                    blankRowIndex.push(x + simpleAdditionalColumns);
                  }
                }

                var columnsSizes = [];
                for (
                  let index = 0;
                  index <
                  this.forecastData.ForecastTable.Headers.length +
                    simpleAdditionalColumns;
                  index++
                ) {
                  if (index === 0) {
                    columnsSizes.push(1.5);
                  } else if (blankRowIndex.includes(index)) {
                    //check for blank row
                    columnsSizes.push(0.15);
                  } else {
                    if (this.forecastData.HideFirstColumn && index === 1)
                      continue;
                    columnsSizes.push(0.365);
                  }
                }

                var tablePosition =
                  this.forecastData.ForecastTable.Headers.length <= 3
                    ? '36%'
                    : this.forecastData.ForecastTable.Headers.length <= 4
                      ? '34%'
                      : this.forecastData.ForecastTable.Headers.length <= 5
                        ? '32%'
                        : this.forecastData.ForecastTable.Headers.length <= 6
                          ? '30%'
                          : this.forecastData.ForecastTable.Headers.length <= 7
                            ? '28%'
                            : this.forecastData.ForecastTable.Headers.length <=
                                8
                              ? '26%'
                              : this.forecastData.ForecastTable.Headers
                                    .length <= 9
                                ? '24%'
                                : this.forecastData.ForecastTable.Headers
                                      .length <= 10
                                  ? '22%'
                                  : this.forecastData.ForecastTable.Headers
                                        .length <= 11
                                    ? '20%'
                                    : this.forecastData.ForecastTable.Headers
                                          .length <= 12
                                      ? '18%'
                                      : this.forecastData.ForecastTable.Headers
                                            .length <= 13
                                        ? '16%'
                                        : this.forecastData.ForecastTable
                                              .Headers.length <= 14
                                          ? '14%'
                                          : this.forecastData.ForecastTable
                                                .Headers.length <= 15
                                            ? '12%'
                                            : this.forecastData.ForecastTable
                                                  .Headers.length <= 18
                                              ? '10%'
                                              : this.forecastData.ForecastTable
                                                    .Headers.length <= 19
                                                ? '8%'
                                                : '0%';

                forecastSlide.addTable(rows, {
                  align: 'center',
                  y: '8%',
                  x: tablePosition,
                  border: { type: 'none' },
                  autoPage: 'true',
                  w: '100%',
                  colW: columnsSizes,
                  rowH: 0.01,
                });

                if (this.forecastData.ForecastRevised) {
                  var revisedImage = '';
                  if (
                    this.forecastData.ForecastRevisedText === 'Forecast Revised'
                  ) {
                    revisedImage = this.getBase64Image(
                      document.getElementById('forecastRevisedBar')
                    );
                  } else if (
                    this.forecastData.ForecastRevisedText ===
                    'Data Trends Adjusted'
                  ) {
                    revisedImage = this.getBase64Image(
                      document.getElementById('dataTrendsBar')
                    );
                  } else if (
                    this.forecastData.ForecastRevisedText ===
                    'Rates-of-Change Adjusted'
                  ) {
                    revisedImage = this.getBase64Image(
                      document.getElementById('ratesOfChangeBar')
                    );
                  }

                  if (revisedImage !== '') {
                    var imagePosition =
                      this.forecastData.ForecastTable.Headers.length <= 3
                        ? this.forecastData.HideFirstColumn
                          ? '50.55%'
                          : '54.5%'
                        : this.forecastData.ForecastTable.Headers.length <= 4
                          ? this.forecastData.HideFirstColumn
                            ? '48.55%'
                            : '52.5%'
                          : this.forecastData.ForecastTable.Headers.length <= 5
                            ? this.forecastData.HideFirstColumn
                              ? '46.55%'
                              : '50.5%'
                            : this.forecastData.ForecastTable.Headers.length <=
                                6
                              ? this.forecastData.HideFirstColumn
                                ? '44.55%'
                                : '48.5%'
                              : this.forecastData.ForecastTable.Headers
                                    .length <= 7
                                ? this.forecastData.HideFirstColumn
                                  ? '42.55%'
                                  : '46.5%'
                                : this.forecastData.ForecastTable.Headers
                                      .length <= 8
                                  ? this.forecastData.HideFirstColumn
                                    ? '40.55%'
                                    : '44.5%'
                                  : this.forecastData.ForecastTable.Headers
                                        .length <= 9
                                    ? this.forecastData.HideFirstColumn
                                      ? '38.55%'
                                      : '42.5%'
                                    : this.forecastData.ForecastTable.Headers
                                          .length <= 10
                                      ? this.forecastData.HideFirstColumn
                                        ? '36.55%'
                                        : '40.5%'
                                      : this.forecastData.ForecastTable.Headers
                                            .length <= 11
                                        ? this.forecastData.HideFirstColumn
                                          ? '34.55%'
                                          : '38.5%'
                                        : this.forecastData.ForecastTable
                                              .Headers.length <= 12
                                          ? this.forecastData.HideFirstColumn
                                            ? '32.55%'
                                            : '36.5%'
                                          : this.forecastData.ForecastTable
                                                .Headers.length <= 13
                                            ? this.forecastData.HideFirstColumn
                                              ? '30.55%'
                                              : '34.5%'
                                            : this.forecastData.ForecastTable
                                                  .Headers.length <= 14
                                              ? this.forecastData
                                                  .HideFirstColumn
                                                ? '28.55%'
                                                : '32.5%'
                                              : this.forecastData.ForecastTable
                                                    .Headers.length <= 15
                                                ? this.forecastData
                                                    .HideFirstColumn
                                                  ? '26.55%'
                                                  : '30.5%'
                                                : this.forecastData
                                                      .ForecastTable.Headers
                                                      .length <= 18
                                                  ? this.forecastData
                                                      .HideFirstColumn
                                                    ? '24.55%'
                                                    : '28.5%'
                                                  : this.forecastData
                                                        .ForecastTable.Headers
                                                        .length <= 19
                                                    ? this.forecastData
                                                        .HideFirstColumn
                                                      ? '22.55%'
                                                      : '26.5%'
                                                    : this.forecastData
                                                          .HideFirstColumn
                                                      ? '14.5%'
                                                      : '18.4%'; //default placement

                    forecastSlide.addImage({
                      data: revisedImage,
                      h: '65%',
                      w: '2%',
                      y: '15.5%',
                      x: imagePosition,
                    });
                  }
                }
              }
            } // Forecast End
            pagesUsed.push('forecast');
          } else if (
            this.apiResponse.PageOrder[y].Value.includes('forecast-history') &&
            !pagesUsed.includes('forecast-history')
          ) {
            {
              // Forecast History Start
              if (this.apiResponse.FCHistoryPage !== null) {
                let forecastSlide = pres.addSlide({
                  masterName: 'MASTER_SLIDE',
                });
                forecastSlide.addText(
                  this.apiResponse.FCHistoryPage.PageTitle,
                  {
                    w: '100%',
                    align: 'center',
                    fontSize: 10,
                    fontFace: 'Calibri',
                    color: '386092',
                    bold: true,
                    y: '5%',
                  }
                );

                let forecastTableHeaders = [
                  {
                    text: '',
                    options: { align: 'center', bold: true, fontSize: 6 },
                  },
                  {
                    text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header1,
                    options: { align: 'center', bold: true, fontSize: 6 },
                  },
                ];

                forecastTableHeaders.push({
                  text: '',
                  options: { fontSize: 6 },
                });

                forecastTableHeaders.push({
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header2,
                  options: { align: 'center', bold: true, fontSize: 6 },
                });

                forecastTableHeaders.push({
                  text: '',
                  options: { fontSize: 6 },
                });

                forecastTableHeaders.push({
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header3,
                  options: { align: 'center', bold: true, fontSize: 6 },
                });

                forecastTableHeaders.push({
                  text: '',
                  options: { fontSize: 6 },
                });

                forecastTableHeaders.push({
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header4,
                  options: { align: 'center', bold: true, fontSize: 6 },
                });

                let rows = [];

                rows.push(forecastTableHeaders);

                // add row data
                for (
                  let i = 0;
                  i < this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length;
                  ++i
                ) {
                  var actualColorFirst = '';
                  var actualColorSecond = '';
                  var actualColorThird = '';
                  var actualColorFourth = '';
                  var actualsFirstColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                      .FirstColumn
                  );
                  var lowerRangeFirstColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                      .FirstColumn
                  );
                  var upperRangeFirstColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                      .FirstColumn
                  );
                  var actualsSecondColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                      .SecondColumn
                  );
                  var lowerRangeSecondColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                      .SecondColumn
                  );
                  var upperRangeSecondColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                      .SecondColumn
                  );
                  var actualsThirdColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                      .ThirdColumn
                  );
                  var lowerRangeThirdColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                      .ThirdColumn
                  );
                  var upperRangeThirdColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                      .ThirdColumn
                  );
                  var actualsFourthColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                      .FourthColumn
                  );
                  var lowerRangeFourthColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                      .FourthColumn
                  );
                  var upperRangeFourthColumn = parseFloat(
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                      .FourthColumn
                  );

                  if (i == 3 || i == 8 || i == 13) {
                    if (
                      actualsFirstColumn >= lowerRangeFirstColumn &&
                      actualsFirstColumn <= upperRangeFirstColumn
                    ) {
                      actualColorFirst = '09A684';
                    } else {
                      actualColorFirst = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                    i == 15
                  ) {
                    if (
                      actualsFirstColumn >= lowerRangeFirstColumn &&
                      actualsFirstColumn <= upperRangeFirstColumn
                    ) {
                      actualColorFirst = '09A684';
                    } else {
                      actualColorFirst = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                    i == 17
                  ) {
                    if (
                      actualsFirstColumn >= lowerRangeFirstColumn &&
                      actualsFirstColumn <= upperRangeFirstColumn
                    ) {
                      actualColorFirst = '09A684';
                    } else {
                      actualColorFirst = 'D2232A';
                    }
                  }

                  if (i == 3 || i == 8 || i == 13) {
                    if (
                      actualsSecondColumn >= lowerRangeSecondColumn &&
                      actualsSecondColumn <= upperRangeSecondColumn
                    ) {
                      actualColorSecond = '09A684';
                    } else {
                      actualColorSecond = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                    i == 15
                  ) {
                    if (
                      actualsSecondColumn >= lowerRangeSecondColumn &&
                      actualsSecondColumn <= upperRangeSecondColumn
                    ) {
                      actualColorSecond = '09A684';
                    } else {
                      actualColorSecond = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                    i == 17
                  ) {
                    if (
                      actualsSecondColumn >= lowerRangeSecondColumn &&
                      actualsSecondColumn <= upperRangeSecondColumn
                    ) {
                      actualColorSecond = '09A684';
                    } else {
                      actualColorSecond = 'D2232A';
                    }
                  }

                  if (i == 3 || i == 8 || i == 13) {
                    if (
                      actualsThirdColumn >= lowerRangeThirdColumn &&
                      actualsThirdColumn <= upperRangeThirdColumn
                    ) {
                      actualColorThird = '09A684';
                    } else {
                      actualColorThird = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                    i == 15
                  ) {
                    if (
                      actualsThirdColumn >= lowerRangeThirdColumn &&
                      actualsThirdColumn <= upperRangeThirdColumn
                    ) {
                      actualColorThird = '09A684';
                    } else {
                      actualColorThird = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                    i == 17
                  ) {
                    if (
                      actualsThirdColumn >= lowerRangeThirdColumn &&
                      actualsThirdColumn <= upperRangeThirdColumn
                    ) {
                      actualColorThird = '09A684';
                    } else {
                      actualColorThird = 'D2232A';
                    }
                  }

                  if (i == 3 || i == 8 || i == 13) {
                    if (
                      actualsFourthColumn >= lowerRangeFourthColumn &&
                      actualsFourthColumn <= upperRangeFourthColumn
                    ) {
                      actualColorFourth = '09A684';
                    } else {
                      actualColorFourth = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                    i == 15
                  ) {
                    if (
                      actualsFourthColumn >= lowerRangeFourthColumn &&
                      actualsFourthColumn <= upperRangeFourthColumn
                    ) {
                      actualColorFourth = '09A684';
                    } else {
                      actualColorFourth = 'D2232A';
                    }
                  } else if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                    i == 17
                  ) {
                    if (
                      actualsFourthColumn >= lowerRangeFourthColumn &&
                      actualsFourthColumn <= upperRangeFourthColumn
                    ) {
                      actualColorFourth = '09A684';
                    } else {
                      actualColorFourth = 'D2232A';
                    }
                  }

                  var fillCol = '';
                  if (i == 1 || i == 3 || i == 6 || i == 8 || i == 11) {
                    fillCol = 'f2f2f2';
                  } else if (
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                      i === 14) ||
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                      i === 15)
                  ) {
                    fillCol = 'f2f2f2';
                  } else if (
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                      i === 15) ||
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                      i === 17)
                  ) {
                    fillCol = 'f2f2f2';
                  }

                  var boldRow = false;
                  if (
                    i == 1 ||
                    i == 3 ||
                    i == 4 ||
                    i == 6 ||
                    i == 8 ||
                    i == 9 ||
                    i == 11 ||
                    i == 13
                  ) {
                    boldRow = true;
                  } else if (
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                      i == 15) ||
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                      .length === 16 &&
                      i == 14)
                  ) {
                    boldRow = true;
                  } else if (
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                      i == 15) ||
                    (this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >
                      16 &&
                      i == 17)
                  ) {
                    boldRow = true;
                  }

                  var row = [
                    {
                      text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[
                        i
                      ].RowTitle,
                      options: {
                        align: 'center',
                        fill: fillCol,
                        bold: boldRow,
                        fontSize: 6,
                      },
                    },
                    {
                      text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[
                        i
                      ].FirstColumn,
                      options: {
                        align: 'center',
                        color: actualColorFirst,
                        fill: fillCol,
                        bold: boldRow,
                        fontSize: 6,
                      },
                    },
                  ];

                  var fcHColumnSizes = [1.75, 1.75];

                  row.push({
                    text: '',
                    options: {
                      align: 'center',
                      fill:
                        !this.apiResponse.FCHistoryPage.FCHistoryTable
                          .WasRevised1 && fillCol !== ''
                          ? 'f2f2f2'
                          : '',
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(0.4);

                  if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised1 !== '' &&
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised1 !== null
                  ) {
                    if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised1 === 'Forecast Revised'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('forecastRevisedBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '36.2%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised1 === 'Data Trends Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('dataTrendsBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '36.2%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised1 === 'Rates-of-Change Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('ratesOfChangeBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '36.2%',
                      });
                    }
                  }

                  row.push({
                    text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                      .SecondColumn,
                    options: {
                      align: 'center',
                      color: actualColorSecond,
                      fill: fillCol,
                      bold: boldRow,
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(1.75);

                  row.push({
                    text: '',
                    options: {
                      align: 'center',
                      fill:
                        !this.apiResponse.FCHistoryPage.FCHistoryTable
                          .WasRevised2 && fillCol !== ''
                          ? 'f2f2f2'
                          : '',
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(0.4);

                  if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised2 !== '' &&
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised2 !== null
                  ) {
                    if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised2 === 'Forecast Revised'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('forecastRevisedBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '57.5%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised2 === 'Data Trends Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('dataTrendsBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '57.5%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised2 === 'Rates-of-Change Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('ratesOfChangeBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '57.5%',
                      });
                    }
                  }

                  row.push({
                    text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                      .ThirdColumn,
                    options: {
                      align: 'center',
                      color: actualColorThird,
                      fill: fillCol,
                      bold: boldRow,
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(1.75);

                  row.push({
                    text: '',
                    options: {
                      align: 'center',
                      fill:
                        !this.apiResponse.FCHistoryPage.FCHistoryTable
                          .WasRevised3 && fillCol !== ''
                          ? 'f2f2f2'
                          : '',
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(0.4);

                  if (
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised3 !== '' &&
                    this.apiResponse.FCHistoryPage.FCHistoryTable
                      .WasRevised3 !== null
                  ) {
                    if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised3 === 'Forecast Revised'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('forecastRevisedBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '78.9%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised3 === 'Data Trends Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('dataTrendsBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '78.9%',
                      });
                    } else if (
                      this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised3 === 'Rates-of-Change Adjusted'
                    ) {
                      forecastSlide.addImage({
                        data: this.getBase64Image(
                          document.getElementById('ratesOfChangeBar')
                        ),
                        h: '65%',
                        w: '2%',
                        y: '15.5%',
                        x: '78.9%',
                      });
                    }
                  }

                  row.push({
                    text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                      .FourthColumn,
                    options: {
                      align: 'center',
                      color: actualColorFourth,
                      fill: fillCol,
                      bold: boldRow,
                      fontSize: 6,
                    },
                  });

                  fcHColumnSizes.push(1.75);

                  rows.push(row);

                  if (i === 4 || i === 9 || i === 13) {
                    var blankRow = [
                      {
                        text: '',
                        border: { type: 'none' },
                        options: { fontSize: 2 },
                      },
                      {
                        text: '',
                        border: { type: 'none' },
                        options: { fontSize: 2 },
                      },
                      {
                        text: '',
                        border: { type: 'none' },
                        options: { fontSize: 2 },
                      },
                      {
                        text: '',
                        border: { type: 'none' },
                        options: { fontSize: 2 },
                      },
                      {
                        text: '',
                        border: { type: 'none' },
                        options: { fontSize: 2 },
                      },
                    ];

                    blankRow.push({
                      text: '',
                      border: { type: 'none' },
                      options: { fontSize: 2 },
                    });
                    blankRow.push({
                      text: '',
                      border: { type: 'none' },
                      options: { fontSize: 2 },
                    });

                    blankRow.push({
                      text: '',
                      border: { type: 'none' },
                      options: { fontSize: 2 },
                    });

                    rows.push(blankRow);
                  }
                }

                forecastSlide.addTable(rows, {
                  align: 'center',
                  y: '8%',
                  x: '0%',
                  border: { type: 'none' },
                  autoPage: 'true',
                  w: '100%',
                  rowH: 0.2,
                  colW: fcHColumnSizes,
                });
              }
            } // Forecast History End
            pagesUsed.push('forecast-history');
          }
        }

        // pres.writeFile({ fileName: this.companyName + '.pptx' }).then(() => {
        //     $('#loadingFileModal').modal('hide');
        // });
        pres.writeFile(this.companyName + '.pptx').then(() => {
          $('#loadingFileModal').modal('hide');
        });
      },
      getBase64Image: function (img) {
        if (img) {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL('image/png');
          // return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
          return dataURL;
        }
      },
      async createCoverPageChart() {
        let trace = {
          type: 'scatter',
          mode: 'scatter',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.HistoricData,
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: true,
        };

        let fcLMRTrace = {
          type: 'scatter',
          mode: 'markers',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.LMRForecast,
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        let fcUMRTrace = {
          type: 'scatter',
          mode: 'markers',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.UMRForecast,
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        for (let i = 0; i < this.apiResponse.CoverPage.MonthYear.length; i++) {
          // const element = this.apiResponse.CoverPage.MonthYear[i];

          if (this.apiResponse.CoverPage.LMRForecast) {
            fcLMRTrace.visible = true;
          }

          if (this.apiResponse.CoverPage.UMRForecast) {
            fcUMRTrace.visible = true;
          }
        }

        //array of all traces to plot
        let chartData = [trace, fcLMRTrace, fcUMRTrace];

        //layout options
        const layout = {
          showlegend: false,
          autosize: true,
          dragmode: 'zoom',
          yaxis: {
            anchor: 'x',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            automargin: true,
            showgrid: false,
            showline: false,
            showticklabels: false,
          },

          xaxis: {
            dtick: 'M24',
            automargin: true,
            showgrid: false,
            showline: false,
            showticklabels: false,
          },
          family: '\\"Open Sans\\", sans-serif',
          size: 12,
          color: '#444',
          height: 600,
          margin: {
            t: 50,
            l: 50,
            r: 50,
            b: 50,
          },
        };

        await Plotly.newPlot('coverPageChart', chartData, layout, {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: [
            'autoScale2d',
            'toImage',
            'sendDataToCloud',
            'lasso2d',
            'toggleSpikelines',
            'resetScale2d',
          ],
          doubleClick: false /*'reset'*/,
        });
      },
      buildEmptyForecastRow() {
        var emptyRow = [];
        for (
          let i = 0;
          i < this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
          i++
        ) {
          const element =
            this.apiResponse.ForecastTablePage.ForecastTable.Headers[i];
          var headerIndex = i;
          var fiscalMonthEnd =
            this.apiResponse.ForecastTablePage.FiscalYearEndMonth;
          var monthEnd = this.monthEnd[headerIndex];

          if (i === 1 && this.apiResponse.ForecastTablePage.HideFirstColumn) {
            if (
              headerIndex === 1 &&
              this.apiResponse.ForecastTablePage.ForecastRevised
            ) {
              if (
                monthEnd === fiscalMonthEnd &&
                this.apiResponse.ForecastTablePage.ForecastTable.Headers
                  .length -
                  1 !==
                  headerIndex
              ) {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              } else {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              }
            } else if (
              monthEnd === fiscalMonthEnd &&
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length -
                1 !==
                headerIndex
            ) {
              emptyRow.push({
                text: '|',
                fillColor: '#FFF',
                color: '#FFF',
              });
            }
          } else {
            if (
              headerIndex === 1 &&
              this.apiResponse.ForecastTablePage.ForecastRevised
            ) {
              if (
                monthEnd === fiscalMonthEnd &&
                this.apiResponse.ForecastTablePage.ForecastTable.Headers
                  .length -
                  1 !==
                  headerIndex
              ) {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              } else {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              }
            } else if (
              monthEnd === fiscalMonthEnd &&
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length -
                1 !==
                headerIndex
            ) {
              emptyRow.push({
                text: '|',
                fillColor: '#FFF',
                color: '#FFF',
              });
            }

            emptyRow.push({
              text: '|',
              fillColor: '#FFF',
              color: '#FFF',
            });
          }
        }

        return emptyRow;
      },
    },
  };
</script>
<style media="screen">
  .tableHeader {
    color: white;
    border: none;
    padding: 1em;
    padding-left: 0;
  }

  .tableHeader:first-child {
    border-radius: 10px 0px 0px 0px;
  }

  .tableHeader:last-child {
    border-radius: 0px 10px 0px 0px;
  }

  .tableDataRow:last-child td:last-child {
    border-radius: 0px 0px 10px 0px;
  }

  .tableDataRow:last-child td:first-child {
    border-radius: 0px 0px 0px 10px;
  }

  .tableDataRow:last-child td {
    border-bottom: 1px solid #ddd;
  }

  .isProofed {
    background: yellow;
  }

  .phaseImg {
    /* margin: 10px; */
    width: 5vw;
    border-radius: 0px 0px 10px 10px;
  }

  @media only screen and (max-width: 999px) {
    .phaseImg {
      width: 6vw;
    }
  }

  @media only screen and (max-width: 799px) {
  }
</style>
